import { Box, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import { RadioButtonGroupSmall } from 'wix-ui-icons-common';

import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

interface TopicsButtonProps {
  onClick: () => void;
}

export const TopicsButton = ({ onClick }: TopicsButtonProps) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      data-hook={DATA_HOOKS.TOPICS_BUTTON}
      className={css.topics}>
      <Tooltip content={t('article-page.topics.tooltip')} enterDelay={300} size="small" moveBy={{ y: 12 }}>
        <Box align="center" verticalAlign="middle" gap="12px">
          <RadioButtonGroupSmall />
          <Text size="small">{t('article-page.topics')}</Text>
        </Box>
      </Tooltip>
    </div>
  );
};
